import Vue from 'vue'
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'

Vue.use(Toaster, { timeout: 7000 })

Vue.axios.interceptors.response.use((response) => {
  let useToaster = response.config.toaster

  if (response.data.message) {
    if (useToaster !== false) {
      Vue.toaster.success(response.data.message)
    }

    return response
  }

  return response
}, (error) => {
  if (error.response.status === 401) {
    Vue.toaster.error(__('Unauthorized'))
    return Promise.reject(error)
  }
  if (error.response.status === 404) {
    Vue.toaster.error(__('Not found'))
    return Promise.reject(error)
  }
  if (error.response.status === 403) {
    Vue.toaster.error(__('Forbidden'))
    return Promise.reject(error)
  }
  if (error.response.status === 500) {
    Vue.toaster.error(__('Internal server error'))
    return Promise.reject(error)
  }

  let useToaster = error.response.config.toaster

  if (useToaster !== false) {
    let message = error.response.data.title
    Vue.toaster.error(message)
  }

  return Promise.reject(error)
})
